export default "__VITE_ASSET__7d5_M4YD__"